__turbopack_context__.v({
  "info-card": "pS8w5G_info-card",
  "info-card__body": "pS8w5G_info-card__body",
  "info-card__button": "pS8w5G_info-card__button",
  "info-card__copy": "pS8w5G_info-card__copy",
  "info-card__heading": "pS8w5G_info-card__heading",
  "info-card__image": "pS8w5G_info-card__image",
  "info-card__picture": "pS8w5G_info-card__picture",
});
